'use client';

import { GradientStarIcon } from '@/components/icons/gradient-star';
import { StarGrayIcon } from '@/components/icons/star-gray';

export interface FanficRatingProps {
  userRating: number;
  hoveredRating: number;
  collectionData: {
    isInCollection?: boolean;
  };
  handleStarClick: (rating: number) => void;
  handleStarHover: (rating: number) => void;
  handleStarLeave: () => void;
  preview?: boolean;
}

/**
 * Компонент FanficRating - отображает звёздный рейтинг фанфика
 */
export function FanficRating({
  userRating,
  hoveredRating,
  collectionData,
  handleStarClick,
  handleStarHover,
  handleStarLeave,
  preview,
}: FanficRatingProps) {
  return (
    <fieldset disabled={preview} className="bg-[#f2f3f7] rounded-xl p-4 disabled:opacity-60">
      <div className="flex flex-col items-center space-y-3">
        <div className="text-[#6E7384]">Ваша оценка:</div>
        <div className="flex items-center">
          {[1, 2, 3, 4, 5].map((star) => {
            const isActive = star <= (hoveredRating || userRating);
            return (
              <button
                type="button"
                key={star}
                className="transition-transform hover:scale-110 px-1"
                onClick={() => handleStarClick(star)}
                onMouseEnter={() => !preview && handleStarHover(star)}
                onMouseLeave={handleStarLeave}
              >
                {isActive ? (
                  <GradientStarIcon className="w-7 h-7" />
                ) : (
                  <StarGrayIcon className="w-7 h-7" />
                )}
              </button>
            );
          })}
        </div>
        {userRating > 0 && <div className="text-sm text-[#6E7384]">Оценка: {userRating} из 5</div>}
      </div>
    </fieldset>
  );
}
